import { ForbiddenWordType } from '../enums';

export const numericForbiddenWordTypeToString = {
  [ForbiddenWordType.block]: 'Block',
  [ForbiddenWordType.score]: 'Score',
};
